import Button from './Button'

export default Button



// WEBPACK FOOTER //
// ./src/app/elements/Button/index.js